module.exports = __webpack_public_path__ + "static/media/transport.bffa7203.jpg";